:host {
    --wcs-accordion-gap: var(--wcs-semantic-spacing-base);

    display: flex;
    flex-direction: column;
    gap: var(--wcs-accordion-gap);
}
